<template>
	<div
		id="egg"
		class="egg-game"
		:class="{ 'dashboard-mode': mode == 'dashboard', borned: isBorned }"
		ref="egg"
	>
		<img src="../../../assets/egg/egg2.png" class="egg-base" />

		<div v-if="currentHero" class="egg-hero">
			<CustomCharacter
				:purchasedItemsList="listOfPurchasedItems"
				:mode="mode"
			/>
		</div>

		<img v-else src="../../../assets/egg/egg3.png" class="egg-hero" />

		<img src="../../../assets/egg/smoke.png" class="egg-smoke" />
		<!-- <img src="../../../assets/egg/egg-top.png" class="egg-top" /> -->
		<div class="line-parent">
			<img src="../../../assets/egg/line-parent.png" />
		</div>
		<div class="line-child1">
			<img src="../../../assets/egg/line-child1.png" />
		</div>
		<div class="line-child2">
			<img src="../../../assets/egg/line-child2.png" />
		</div>
		<div class="line-child3">
			<img src="../../../assets/egg/line-child3.png" />
		</div>
		<div class="line-child4">
			<img src="../../../assets/egg/line-child5.png" />
		</div>
	</div>
</template>

<script>
import CustomCharacter from '../../DashboardStudent/Shop/CustomCharacter.vue'

let intervalId

export default {
	name: 'character',
	components: {
		CustomCharacter,
	},
	props: ['mode'],
	data: () => ({
		count: Number(localStorage.getItem('totalRight')),
		appDevMode: process.env.VUE_APP_ENV == 'dev',
		listOfPurchasedItems: null,
		isBorned: false,
	}),
	watch: {},
	methods: {
		updateCharacter() {
			this.listOfPurchasedItems = JSON.parse(
				localStorage.getItem('savedActiveItems')
			)
		},
		borneCharacter() {
			let w = this.$refs.egg.offsetWidth * 0.5865
			document.querySelectorAll(
				'.egg-game .line-parent img'
			)[0].style.width = `${w}px`
			this.$refs.egg.classList.add('crack')
			intervalId = setTimeout(() => {
				this.$refs.egg.classList.add('smoke')
				intervalId = setTimeout(() => {
					this.$refs.egg.classList.add('badam')
					intervalId = setTimeout(() => {
						this.$refs.egg.classList.remove('badam')
						intervalId = setTimeout(() => {
							document.querySelectorAll('.egg-base')[0].style.display = 'none'
							document.querySelectorAll('.egg-hero')[0].style.display = 'block'
							this.$refs.egg.classList.remove('smoke')
							this.$refs.egg.classList.add('hero')

							this.isBorned = true
						}, 600)
					}, 600)
				}, 100)
			}, 900)
		},
	},
	computed: {
		currentHero() {
			return (
				this.listOfPurchasedItems?.find(
					el => el.item?.category == 'HERO' && el.is_activated == true
				) || null
			)
		},
		isHeroActive() {
			const isBorned = this.appDevMode ? this.count >= 20 : this.count >= 300

			return isBorned
		},
	},
	watch: {
		isHeroActive(newValue) {
			if (newValue) {
				this.borneCharacter()
			}
		},
	},
	beforeDestroy() {
		clearInterval(intervalId)
	},
	beforeMount() {
		const isReadOnly = this.$route.query.read_only !== undefined
		const targetUserId =
			this.$route.query.read_only || this.$store.state.myProfile.id

		if (!isReadOnly && localStorage.savedActiveItems) {
			this.listOfPurchasedItems = JSON.parse(
				localStorage.getItem('savedActiveItems')
			)
		} else {
			const url = isReadOnly
				? `/eshop/items/purchased?user=${targetUserId}`
				: '/eshop/items/purchased'

			this.axios({ url })
				.then(({ data }) => {
					if (data) {
						const listOfActiveItems = data.filter(
							el => el.is_activated === true
						)

						this.listOfPurchasedItems = listOfActiveItems

						if (!isReadOnly) {
							localStorage.setItem(
								'savedActiveItems',
								JSON.stringify(listOfActiveItems)
							)
						}
					} else {
						this.listOfPurchasedItems = { error: 'Error has occurred' }
					}
				})
				.catch(() => {
					this.listOfPurchasedItems = { error: 'Error has occurred' }
				})
		}

		console.log('count', localStorage.getItem('totalRight'))

		if (!this.count) {
			let now = new Date()
			let day = now.getDate()
			let month = now.getMonth() + 1
			let year = now.getFullYear()

			try {
				this.axios({
					method: 'get',
					url: `lessons/game/data/statistic?day=${day}&month=${month}&year=${year}&user=${this
						.$route.query.read_only || this.$store.state.myProfile.id}`,
				}).then(response => {
					this.count = Number(response?.data?.all_time?.total_right)

					localStorage.setItem('totalPlayed', response?.data?.all_time?.total)
					localStorage.setItem(
						'totalRight',
						response?.data?.all_time?.total_right
					)
				})
			} catch (e) {
				console.log(e)
			}
		}
	},
	mounted() {
		if (this.isHeroActive) {
			this.borneCharacter()
		}
	},
	created() {
		this.$root.$refs.character = this
	},
}
</script>

<style lang="scss" scoped>
.egg-game {
	position: fixed;
	width: 200px;
	top: calc(95% - 170px);
	right: 3%;

	&.dashboard-mode {
		position: absolute;

		left: 50%;
		top: 50%;

		transform: translate(-48%, -55%);
		transform-origin: top;

		@media (max-width: 1220px) {
			transform: translate(-58%, -55%);
		}
	}
}

.egg-game img {
	max-width: 100%;
}

.egg-game .egg-smoke {
	position: absolute;
	top: 10%;
	left: 0%;
	z-index: 10;
	transform-origin: 50% 70%;
	transform: scale(0.45);
	opacity: 0;
	transition: 0.6s;
}

.egg-game .egg-hero {
	display: none;

	position: relative;
}

.egg-game.hero .line-parent,
.egg-game.hero .line-child1,
.egg-game.hero .line-child2,
.egg-game.hero .line-child3,
.egg-game.hero .line-child4,
.egg-game.hero .line-child5 {
	display: none;
}

.egg-game .line-child1 img,
.egg-game .line-child2 img,
.egg-game .line-child3 img,
.egg-game .line-child4 img,
.egg-game .line-child5 img {
	max-height: initial;
}

.egg-game .egg-top {
	width: 58.65%;
	top: 30.7%;
	left: 20.36%;
	position: absolute;
	transition: 0.6s;
	visibility: hidden;
}

.egg-game.badam .egg-top {
	transform: translate(22%, -88%) rotate(30deg);
	visibility: visible;
}

.egg-game .line-parent {
	position: absolute;
	top: 50.7%;
	left: 20.36%;
	width: 0;
	height: 13.37%;
	transition: 0.9s;
	transition-timing-function: linear;
	overflow: hidden;
}

.egg-game .line-parent img {
	position: absolute;
	top: 0;
	left: 0;
	max-width: initial;
}

.egg-game .line-child1 {
	position: absolute;
	top: 57.7%;
	left: 24.36%;
	width: 5%;
	height: 0;
	overflow: hidden;
	transition: 0.3s;
	transition-delay: 0.2s;
}

.egg-game .line-child2 {
	position: absolute;
	top: 63.7%;
	left: 41.36%;
	width: 15%;
	height: 0;
	overflow: hidden;
	transition: 0.3s;
	transition-delay: 0.3s;
}

.egg-game .line-child3 {
	position: absolute;
	bottom: 38%;
	left: 44%;
	width: 6%;
	height: 0;
	overflow: hidden;
	transition: 0.3s;
	transition-delay: 0.6s;
}

.egg-game .line-child4 {
	position: absolute;
	bottom: 42.7%;
	left: 59.36%;
	width: 4%;
	height: 0;
	overflow: hidden;
	transition: 0.3s;
	transition-delay: 0.6s;
}

.egg-game .line-child3 img,
.egg-game .line-child4 img {
	position: absolute;
	bottom: 0;
}

/*crack*/
.egg-game.crack .line-parent {
	width: 58.65%;
}

.egg-game.crack .line-child1 {
	height: 8.37%;
}

.egg-game.crack .line-child2 {
	height: 10.37%;
}

.egg-game.crack .line-child3 {
	height: 9.37%;
}

.egg-game.crack .line-child4 {
	height: 14.37%;
}

/*smoke*/
.egg-game.smoke .egg-smoke {
	opacity: 1;
	transform: scale(1.5);
	transition-timing-function: cubic-bezier(0.04, 1.12, 0, 1.85);
}

@media screen and (max-width: 800px) {
	.egg-game {
		position: relative;

		width: 230px;
		height: 300px;
		top: calc(98% - 114px);
		/* left: 20%; */

		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);

		margin-top: 50px;
	}
}

/*borned*/
.egg-game.borned .egg-base {
	display: none;
}

.egg-game.borned .egg-hero {
	display: block;
}

.egg-game.borned .egg-smoke {
	display: none;
}

@media screen and (max-width: 800px) {
	.egg-hero {
		display: block;

		height: 200px;
	}
}
</style>
